export const homeTranslations = {
    en: {
        hero: {
            badge: "Expert Investigative Coverage: Punjab & Haryana",
            title: "Strategic Investigation, Police Liaison & Risk Mitigation for Insurance Claims",
            description: "High-precision field investigation, direct coordination with Police and statutory authorities, RTI-based evidence procurement, and IBNR–FFRM risk verification support for India's leading insurance companies.",
            activeSince: "Active Since 2007",
            ibnr: "IBNR–FFRM Since Aug 2022",
            team: "20+ Backend Team",
            officers: "Dedicated Field Officers",
            ctaPrimary: "Request Investigation",
            ctaSecondary: "Call +91-9814974333",
            location: "Operating from Mohali with strong law-enforcement and insurer coordination across Punjab and Haryana."
        },
        whoWeAre: {
            title: "Who We Are",
            p1: "<strong>Gagandeep Singh & Associates (GSA)</strong> is a premier investigative and insurance risk-verification firm providing claim validation, fraud-risk mitigation, police liaison, and statutory support services to leading private insurance companies in India.",
            p2: "From our Mohali headquarters, we deliver reliable field intelligence and structured authority coordination to protect insurers from fraudulent claims, exaggerated losses, and legal exposure.",
            p3: "Led by <strong>Gagandeep Singh</strong>, a specialist in insurance investigation and law-enforcement liaison, GSA is a trusted partner for ground-level verification across Punjab and Haryana.",
            p4: "Active in the industry since 2007, GSA is supported by a 20-member backend operations team and an experienced field officer network, enabling rapid execution, effective police liaison, accurate verification, and timely delivery of evidence-based reports.",
            highlight: "Since August 2022, the firm has additionally been engaged in IBNR and FFRM insurance risk-management projects, expanding its role from investigation to proactive claim-risk detection and portfolio-level verification support for insurers."
        },
        specializations: {
            title: "Our Core Specializations",
            subtitle: "Comprehensive investigation and verification services backed by police liaison expertise",
            motor: {
                title: "Motor Insurance Investigations (TP, OD & Theft)",
                desc: "End-to-end technical verification of motor claims with police-verified ground evidence.",
                tp: "Third-Party (TP) Claims",
                tpList: ["Accident legitimacy & police record verification", "Victim and occupant confirmation", "Place of Occurrence (POO) mapping", "Witness tracing & police statement correlation"],
                od: "Own Damage (OD) Scrutiny",
                odList: ["Damage vs loss cause correlation", "Police intimation consistency", "Pre-existing damage detection"],
                theft: "Theft Investigations",
                theftList: ["FIR authenticity & police station verification", "Theft circumstance validation", "Key-set authenticity", "Untraced report coordination"]
            },
            police: {
                title: "Police Liaison & Statutory Coordination",
                desc: "Professional dealing and coordination with law-enforcement agencies.",
                list: ["Direct liaison with Police Stations & Investigating Officers", "FIR / DDR / accident record confirmation", "Charge-sheet (173 CrPC) verification", "Case status & investigation updates", "SSP / SHO / IO office coordination"]
            },
            rti: {
                title: "RTI (Right to Information) Expert Services",
                desc: "RTI-based retrieval of certified police and government records.",
                list: ["RTI drafting & filing with Police, RTO & Hospitals", "Certified FIR, DDR, MLC & investigation records", "Difficult police document procurement", "Legally admissible evidence"]
            },
            risk: {
                title: "IBNR Risk Verification (Since Aug 2022)",
                desc: "Portfolio-level and early-stage insurance risk detection support.",
                list: ["IBNR (Incurred But Not Reported) investigation", "Suspicious pattern identification", "Pre-claim field validation", "Policy-stage risk intelligence inputs"]
            },
            accidentData: {
                title: "Road Traffic Accident Data Retrieval",
                desc: "Specialized retrieval of road traffic accident data for general insurance companies.",
                list: ["Accident data retrieval for insurers", "Traffic accident record verification", "Data support for claim processing"]
            }
        },
        process: {
            title: "Our Investigation & Verification Process",
            subtitle: "Designed for police-verified, legally defensible evidence",
            steps: [
                { title: "Case Intake & Scope Definition", desc: "Claim / IBNR brief, documents, required confirmations." },
                { title: "Field Investigation & Police Coordination", desc: "Site visit, police enquiry, IO interaction, local intelligence." },
                { title: "Official Record & Risk Validation", desc: "Police records, RTI documents, FFRM / IBNR checks." },
                { title: "Structured Final Report Submission", desc: "Findings, inconsistencies, photographs & conclusions." }
            ],
            ctaText: "Need urgent police or IBNR verification?",
            ctaBtn: "Call for Priority Processing"
        },
        coverage: {
            title: "Expert Investigative Coverage",
            subtitle: "Strong police liaison and insurer coordination across operational zones",
            punjab: { title: "Punjab", desc: "Mohali, Chandigarh, Ludhiana, Amritsar, Patiala & statewide" },
            haryana: { title: "Haryana", desc: "Panchkula, Ambala, Karnal & surrounding districts" }
        },
        expandedStates: {
            title: "Extended State Coverage",
            desc: "Active operations in Uttar Pradesh, Uttarakhand, Jharkhand, Bihar, Chhattisgarh, Maharashtra & others.",
            list: ["Uttar Pradesh", "Uttarakhand", "Jharkhand", "Bihar", "Chhattisgarh", "Maharashtra"]
        },
        advantage: {
            title: "The GSA Advantage",
            items: [
                { title: "Active Since 2007", desc: "Established investigation & insurer credibility" },
                { title: "IBNR–FFRM Projects Since Aug 2022", desc: "Expanded into risk-verification domain" },
                { title: "Police Liaison Expertise", desc: "Direct dealing with SHO, IO & SSP offices" },
                { title: "20+ Backend & Field Team", desc: "Strong documentation & execution" },
                { title: "Fraud Detection Expertise", desc: "Staged accidents & false narratives detection" },
                { title: "Evidence-Based Reporting", desc: "Police inputs + site photos + witness statements" },
                { title: "Panel-Ready Structured Reports", desc: "Aligned with insurer & legal formats" },
                { title: "Rapid Turnaround (TAT)", desc: "Time-bound delivery" }
            ]
        },
        industries: {
            title: "Industries We Serve",
            cardTitle: "Private General Insurance Companies",
            items: ["Claims & Risk Departments", "IBNR / FFRM Project Teams", "Legal & Recovery Units", "Corporate Investigation Teams"]
        },
        cta: {
            title: "Ready to Protect Your Insurance Portfolio?",
            desc: "Get expert investigation and risk verification services from Punjab & Haryana's trusted specialists",
            btnPrimary: "Request Investigation",
            btnSecondary: "Call +91-9814974333"
        }
    },
    hi: {
        hero: {
            badge: "विशेषज्ञ जांच कवरेज: पंजाब और हरियाणा",
            title: "बीमा दावों के लिए रणनीतिक जांच, पुलिस संपर्क और जोखिम न्यूनीकरण",
            description: "उच्च-सटीक क्षेत्र जांच, पुलिस और वैधानिक अधिकारियों के साथ सीधा समन्वय, आरटीआई-आधारित साक्ष्य खरीद, और भारत की प्रमुख बीमा कंपनियों के लिए IBNR-FFRM जोखिम सत्यापन समर्थन।",
            activeSince: "2007 से सक्रिय",
            ibnr: "अगस्त 2022 से IBNR-FFRM",
            team: "20+ बैकएंड टीम",
            officers: "समर्पित फील्ड अधिकारी",
            ctaPrimary: "जांच का अनुरोध करें",
            ctaSecondary: "कॉल करें +91-9814974333",
            location: "पंजाब और हरियाणा में मजबूत कानून-प्रवर्तन और बीमाकर्ता समन्वय के साथ मोहाली से कार्यशील।"
        },
        whoWeAre: {
            title: "हम कौन हैं",
            p1: "<strong>गगनदीप सिंह एंड एसोसिएट्स (GSA)</strong> एक प्रमुख खोजी और बीमा जोखिम-सत्यापन फर्म है जो भारत में प्रमुख निजी बीमा कंपनियों को दावा सत्यापन, धोखाधड़ी-जोखिम न्यूनीकरण, पुलिस संपर्क और वैधानिक सहायता सेवाएं प्रदान करती है।",
            p2: "मोहाली मुख्यालय से, हम बीमाकर्ताओं को धोखाधड़ी के दावों, अतिरंजित नुकसान और कानूनी जोखिम से बचाने के लिए विश्वसनीय फील्ड इंटेलिजेंस और संरचित प्राधिकरण समन्वय प्रदान करते हैं।",
            p3: "<strong>गगनदीप सिंह</strong> के नेतृत्व में, जो बीमा जांच और कानून-प्रवर्तन संपर्क में विशेषज्ञ हैं, GSA पंजाब और हरियाणा में जमीनी स्तर के सत्यापन के लिए एक विश्वसनीय भागीदार है।",
            p4: "2007 से उद्योग में सक्रिय, GSA को 20-सदस्यीय बैकएंड ऑपरेशन टीम और एक अनुभवी फील्ड ऑफिसर नेटवर्क का समर्थन प्राप्त है, जो तेजी से निष्पादन, प्रभावी पुलिस संपर्क, सटीक सत्यापन और साक्ष्य-आधारित रिपोर्टों की समय पर डिलीवरी को सक्षम बनाता है।",
            highlight: "अगस्त 2022 से, फर्म IBNR और FFRM बीमा जोखिम-प्रबंधन परियोजनाओं में भी लगी हुई है, जो जांच से लेकर सक्रिय दावा-जोखिम का पता लगाने और बीमाकर्ताओं के लिए पोर्टफोलियो-स्तरीय सत्यापन सहायता तक अपनी भूमिका का विस्तार कर रही है।"
        },
        specializations: {
            title: "हमारी मुख्य विशेषज्ञता",
            subtitle: "पुलिस संपर्क विशेषज्ञता द्वारा समर्थित व्यापक जांच और सत्यापन सेवाएं",
            motor: {
                title: "मोटर बीमा जांच (TP, OD और चोरी)",
                desc: "पुलिस-सत्यापित जमीनी सबूतों के साथ मोटर दावों का एंड-टू-एंड तकनीकी सत्यापन।",
                tp: "तृतीय-पक्ष (TP) दावे",
                tpList: ["दुर्घटना वैधता और पुलिस रिकॉर्ड सत्यापन", "पीड़ित और रहने वाले की पुष्टि", "घटना स्थल (POO) मानचित्रण", "गवाह का पता लगाना और पुलिस बयान सहसंबंध"],
                od: "स्वयं क्षति (OD) जांच",
                odList: ["नुकसान बनाम हानि कारण सहसंबंध", "पुलिस सूचना स्थिरता", "पूर्व-मौजूद क्षति का पता लगाना"],
                theft: "चोरी की जांच",
                theftList: ["एफआईआर प्रमाणिकता और पुलिस स्टेशन सत्यापन", "चोरी की परिस्थिति का सत्यापन", "की-सेट प्रमाणिकता", "अनट्रेस्ड रिपोर्ट समन्वय"]
            },
            police: {
                title: "पुलिस संपर्क और वैधानिक समन्वय",
                desc: "कानून प्रवर्तन एजेंसियों के साथ पेशेवर व्यवहार और समन्वय।",
                list: ["पुलिस स्टेशनों और जांच अधिकारियों के साथ सीधा संपर्क", "एफआईआर / डीडीआर / दुर्घटना रिकॉर्ड की पुष्टि", "चार्जशीट (173 सीआरपीसी) सत्यापन", "केस की स्थिति और जांच अपडेट", "एसएसपी / एसएचओ / आईओ कार्यालय समन्वय"]
            },
            rti: {
                title: "आरटीआई (सूचना का अधिकार) विशेषज्ञ सेवाएं",
                desc: "प्रमाणित पुलिस और सरकारी रिकॉर्ड की आरटीआई-आधारित पुनर्प्राप्ति।",
                list: ["पुलिस, आरटीओ और अस्पतालों के साथ आरटीआई का मसौदा तैयार करना और दाखिल करना", "प्रमाणित एफआईआर, डीडीआर, एमएलसी और जांच रिकॉर्ड", "कठिन पुलिस दस्तावेज़ की खरीद", "कानूनी रूप से स्वीकार्य सबूत"]
            },
            risk: {
                title: "IBNR जोखिम सत्यापन (अगस्त 2022 से)",
                desc: "पोर्टफोलियो-स्तरीय और प्रारंभिक चरण बीमा जोखिम का पता लगाने में सहायता।",
                list: ["IBNR (घटित लेकिन रिपोर्ट नहीं किया गया) जांच", "संदिग्ध पैटर्न की पहचान", "पूर्व-दावा फील्ड सत्यापन", "पॉलिसी-स्टेज जोखिम खुफिया इनपुट"]
            },
            accidentData: {
                title: "Road Traffic Accident Data Retrieval",
                desc: "Specialized retrieval of road traffic accident data for general insurance companies.",
                list: ["Accident data retrieval for insurers", "Traffic accident record verification", "Data support for claim processing"]
            }
        },
        process: {
            title: "हमारी जांच और सत्यापन प्रक्रिया",
            subtitle: "पुलिस-सत्यापित, कानूनी रूप से रक्षा योग्य सबूतों के लिए डिज़ाइन किया गया",
            steps: [
                { title: "केस का प्रकार और दायरा परिभाषा", desc: "दावा / IBNR संक्षिप्त, दस्तावेज, आवश्यक पुष्टि।" },
                { title: "फील्ड जांच और पुलिस समन्वय", desc: "साइट का दौरा, पुलिस पूछताछ, आईओ बातचीत, स्थानीय खुफिया।" },
                { title: "आधिकारिक रिकॉर्ड और जोखिम सत्यापन", desc: "पुलिस रिकॉर्ड, आरटीआई दस्तावेज, FFRM / IBNR चेक।" },
                { title: "संरचित अंतिम रिपोर्ट सबमिशन", desc: "निष्कर्ष, विसंगतियां, तस्वीरें और निष्कर्ष।" }
            ],
            ctaText: "तत्काल पुलिस या IBNR सत्यापन की आवश्यकता है?",
            ctaBtn: "प्राथमिकता प्रसंस्करण के लिए कॉल करें"
        },
        coverage: {
            title: "विशेषज्ञ जांच कवरेज",
            subtitle: "परिचालन क्षेत्रों में मजबूत पुलिस संपर्क और बीमाकर्ता समन्वय",
            punjab: { title: "पंजाब", desc: "मोहाली, चंडीगढ़, लुधियाना, अमृतसर, पटियाला और राज्यव्यापी" },
            haryana: { title: "हरियाणा", desc: "पंचकुला, अंबाला, करनाल और आसपास के जिले" }
        },
        expandedStates: {
            title: "विस्तारित राज्य कवरेज",
            desc: "उत्तर प्रदेश, उत्तराखंड, झारखंड, बिहार, छत्तीसगढ़, महाराष्ट्र और अन्य में सक्रिय संचालन।",
            list: ["उत्तर प्रदेश", "उत्तराखंड", "झारखंड", "बिहार", "छत्तीसगढ़", "महाराष्ट्र"]
        },
        advantage: {
            title: "GSA का लाभ",
            items: [
                { title: "2007 से सक्रिय", desc: "स्थापित जांच और बीमाकर्ता विश्वसनीयता" },
                { title: "अगस्त 2022 से IBNR-FFRM परियोजनाएं", desc: "जोखिम-सत्यापन डोमेन में विस्तार" },
                { title: "पुलिस संपर्क विशेषज्ञता", desc: "एसएचओ, आईओ और एसएसपी कार्यालयों के साथ सीधा व्यवहार" },
                { title: "20+ बैकएंड और फील्ड टीम", desc: "मजबूत दस्तावेज़ीकरण और निष्पादन" },
                { title: "धोखाधड़ी का पता लगाने में विशेषज्ञता", desc: "मंचित दुर्घटनाओं और झूठी कथाओं का पता लगाना" },
                { title: "साक्ष्य-आधारित रिपोर्टिंग", desc: "पुलिस इनपुट + साइट तस्वीरें + गवाह के बयान" },
                { title: "पैनल-तैयार संरचित रिपोर्ट", desc: "बीमाकर्ता और कानूनी प्रारूपों के साथ गठबंधन" },
                { title: "तेजी से बदलाव (TAT)", desc: "समयबद्ध वितरण" }
            ]
        },
        industries: {
            title: "उद्योग जिनकी हम सेवा करते हैं",
            cardTitle: "निजी सामान्य बीमा कंपनियां",
            items: ["दावा और जोखिम विभाग", "IBNR / FFRM प्रोजेक्ट टीमें", "कानूनी और वसूली इकाइयां", "कॉर्पोरेट जांच टीमें"]
        },
        cta: {
            title: "अपने बीमा पोर्टफोलियो की सुरक्षा के लिए तैयार हैं?",
            desc: "पंजाब और हरियाणा के विश्वसनीय विशेषज्ञों से विशेषज्ञ जांच और जोखिम सत्यापन सेवाएं प्राप्त करें",
            btnPrimary: "जांच का अनुरोध करें",
            btnSecondary: "कॉल करें +91-9814974333"
        }
    },
    pa: {
        hero: {
            badge: "ਮਾਹਰ ਜਾਂਚ ਕਵਰੇਜ: ਪੰਜਾਬ ਅਤੇ ਹਰਿਆਣਾ",
            title: "ਬੀਮਾ ਦਾਅਵਿਆਂ ਲਈ ਰਣਨੀਤਕ ਜਾਂਚ, ਪੁਲਿਸ ਤਾਲਮੇਲ ਅਤੇ ਜੋਖਮ ਘਟਾਉਣਾ",
            description: "ਭਾਰਤ ਦੀਆਂ ਪ੍ਰਮੁੱਖ ਬੀਮਾ ਕੰਪਨੀਆਂ ਲਈ ਉੱਚ-ਸ਼ੁੱਧਤਾ ਵਾਲੀ ਖੇਤਰੀ ਜਾਂਚ, ਪੁਲਿਸ ਅਤੇ ਕਾਨੂੰਨੀ ਅਧਿਕਾਰੀਆਂ ਨਾਲ ਸਿੱਧਾ ਤਾਲਮੇਲ, ਆਰਟੀਆਈ-ਅਧਾਰਤ ਸਬੂਤ ਪ੍ਰਾਪਤੀ, ਅਤੇ IBNR-FFRM ਜੋਖਮ ਤਸਦੀਕ ਸਹਾਇਤਾ।",
            activeSince: "2007 ਤੋਂ ਸਰਗਰਮ",
            ibnr: "ਅਗਸਤ 2022 ਤੋਂ IBNR-FFRM",
            team: "20+ ਬੈਕਐਂਡ ਟੀਮ",
            officers: "ਸਮਰਪਿਤ ਫੀਲਡ ਅਫਸਰ",
            ctaPrimary: "ਜਾਂਚ ਦੀ ਬੇਨਤੀ ਕਰੋ",
            ctaSecondary: "ਕਾਲ ਕਰੋ +91-9814974333",
            location: "ਮੋਹਾਲੀ ਤੋਂ ਪੰਜਾਬ ਅਤੇ ਹਰਿਆਣਾ ਵਿੱਚ ਮਜ਼ਬੂਤ ਕਾਨੂੰਨ ਲਾਗੂ ਕਰਨ ਵਾਲੇ ਅਤੇ ਬੀਮਾਕर्ता ਤਾਲਮੇਲ ਨਾਲ ਕੰਮ ਕਰਨਾ।"
        },
        whoWeAre: {
            title: "ਅਸੀਂ ਕੌਣ ਹਾਂ",
            p1: "<strong>ਗਗਨਦੀਪ ਸਿੰਘ ਐਂਡ ਐਸੋਸੀਏਟਸ (GSA)</strong> ਇੱਕ ਪ੍ਰਮੁੱਖ ਜਾਂਚ ਅਤੇ ਬੀਮਾ ਜੋਖਮ-ਪ੍ਰਮਾਣਿਕਤਾ ਫਰਮ ਹੈ ਜੋ ਭਾਰਤ ਵਿੱਚ ਪ੍ਰਮੁੱਖ ਨਿੱਜੀ ਬੀਮਾ ਕੰਪਨੀਆਂ ਨੂੰ ਦਾਅਲੇ ਦੀ ਪ੍ਰਮਾਣਿਕਤਾ, ਧੋਖਾਧੜੀ-ਜੋਖਮ ਘਟਾਉਣ, ਪੁਲਿਸ ਸੰਪਰਕ ਅਤੇ ਕਾਨੂੰਨੀ ਸਹਾਇਤਾ ਸੇਵਾਵਾਂ ਪ੍ਰਦਾਨ ਕਰਦੀ ਹੈ।",
            p2: "ਸਾਡੇ ਮੋਹਾਲੀ ਹੈੱਡਕੁਆਰਟਰ ਤੋਂ, ਅਸੀਂ ਬੀਮਾਕਰਤਾਵਾਂ ਨੂੰ ਧੋਖਾਧੜੀ ਵਾਲੇ ਦਾਅਵਿਆਂ, ਵਧੇ ਹੋਏ ਨੁਕਸਾਨਾਂ ਅਤੇ ਕਾਨੂੰਨੀ ਜੋਖਮ ਤੋਂ ਬਚਾਉਣ ਲਈ ਭਰੋਸੇਯੋਗ ਫੀਲਡ ਇੰਟੈਲੀਜੈਂਸ ਅਤੇ ਢਾਂਚਾਗਤ ਅਥਾਰਟੀ ਤਾਲਮੇਲ ਪ੍ਰਦਾਨ ਕਰਦੇ ਹਾਂ।",
            p3: "<strong>ਗਗਨਦੀਪ ਸਿੰਘ</strong> ਦੀ ਅਗਵਾਈ ਹੇਠ, ਜੋ ਬੀਮਾ ਜਾਂਚ ਅਤੇ ਕਾਨੂੰਨ ਲਾਗੂ ਕਰਨ ਵਾਲੇ ਸੰਪਰਕ ਵਿੱਚ ਮਾਹਰ ਹਨ, GSA ਪੰਜਾਬ ਅਤੇ ਹਰਿਆਣਾ ਵਿੱਚ ਜ਼ਮੀਨੀ ਪੱਧਰ ਦੀ ਤਸਦੀਕ ਲਈ ਇੱਕ ਭਰੋਸੇਮੰਦ ਭਾਈਵਾਲ ਹੈ।",
            p4: "2007 ਤੋਂ ਉਦਯੋਗ ਵਿੱਚ ਸਰਗਰਮ, GSA ਨੂੰ 20-ਮੈਂਬਰੀ ਬੈਕਐਂਡ ਸੰਚਾਲਨ ਟੀਮ ਅਤੇ ਇੱਕ ਤਜਰਬੇਕਾਰ ਫੀਲਡ ਅਫਸਰ ਨੈਟਵਰਕ ਦੁਆਰਾ ਸਮਰਥਨ ਪ੍ਰਾਪਤ ਹੈ, ਜੋ ਤੇਜ਼ੀ ਨਾਲ ਅਮਲ, ਪ੍ਰਭਾਵਸ਼ਾਲੀ ਪੁਲਿਸ ਤਾਲਮੇਲ, ਸਹੀ ਤਸਦੀਕ ਅਤੇ ਸਬੂਤ-ਆਧਾਰਿਤ ਰਿਪੋਰਟਾਂ ਦੀ ਸਮੇਂ ਸਿਰ ਡਿਲਿਵਰੀ ਨੂੰ ਸਮਰੱਥ ਬਣਾਉਂਦਾ ਹੈ।",
            highlight: "ਅਗਸਤ 2022 ਤੋਂ, ਫਰਮ IBNR ਅਤੇ FFRM ਬੀਮਾ ਜੋਖਮ-ਪ੍ਰਬੰਧਨ ਪ੍ਰੋਜੈਕਟਾਂ ਵਿੱਚ ਵੀ ਸ਼ਾਮਲ ਹੈ, ਜੋ ਜਾਂਚ ਤੋਂ ਲੈ ਕੇ ਕਿਰਿਆਸ਼ੀਲ ਦਾਅਵਾ-ਜੋਖਮ ਖੋਜ ਅਤੇ ਬੀਮਾਕਰਤਾਵਾਂ ਲਈ ਪੋਰਟਫੋਲੀਓ-ਪੱਧਰ ਦੀ ਤਸਦੀਕ ਸਹਾਇਤਾ ਤੱਕ ਆਪਣੀ ਭੂਮਿਕਾ ਦਾ ਵਿਸਤਾਰ ਕਰ ਰਹੀ ਹੈ।"
        },
        specializations: {
            title: "ਸਾਡੀ ਮੁੱਖ ਮੁਹਾਰਤ",
            subtitle: "ਪੁਲਿਸ ਤਾਲਮੇਲ ਮਹਾਰਤ ਦੁਆਰਾ ਸਮਰਥਤ ਵਿਆਪਕ ਜਾਂਚ ਅਤੇ ਤਸਦੀਕ ਸੇਵਾਵਾਂ",
            motor: {
                title: "ਮੋਟਰ ਬੀਮਾ ਜਾਂਚ (TP, OD ਅਤੇ ਚੋਰੀ)",
                desc: "ਪੁਲਿਸ ਦੁਆਰਾ ਪ੍ਰਮਾਣਿਤ ਜ਼ਮੀਨੀ ਸਬੂਤਾਂ ਦੇ ਨਾਲ ਮੋਟਰ ਦਾਅਵਿਆਂ ਦੀ ਸ਼ੁਰੂ ਤੋਂ ਅੰਤ ਤੱਕ ਤਕਨੀਕੀ ਤਸਦੀਕ।",
                tp: "ਥਰਡ-ਪਾਰਟੀ (TP) ਦਾਅਵੇ",
                tpList: ["ਹਾਦਸੇ ਦੀ ਜਾਇਜ਼ਤਾ ਅਤੇ ਪੁਲਿਸ ਰਿਕਾਰਡ ਦੀ ਤਸਦੀਕ", "ਪੀੜਤ ਅਤੇ ਸਵਾਰ ਦੀ ਪੁਸ਼ਟੀ", "ਘਟਨਾ ਸਥਾਨ (POO) ਮੈਪਿੰਗ", "ਗਵਾਹ ਦਾ ਪਤਾ ਲਗਾਉਣਾ ਅਤੇ ਪੁਲਿਸ ਬਿਆਨ ਸਬੰਧ"],
                od: "ਆਪਣਾ ਨੁਕਸਾਨ (OD) ਜਾਂਚ",
                odList: ["ਨੁਕਸਾਨ ਬਨਾਮ ਨੁਕਸਾਨ ਦਾ ਕਾਰਨ ਸਬੰਧ", "ਪੁਲਿਸ ਇੰਟੀਮੇਸ਼ਨ ਇਕਸਾਰਤਾ", "ਪਹਿਲਾਂ ਤੋਂ ਮੌਜੂਦ ਨੁਕਸਾਨ ਦੀ ਖੋਜ"],
                theft: "ਚੋਰੀ ਦੀ ਜਾਂਚ",
                theftList: ["ਐਫਆਈਆਰ ਦੀ ਪ੍ਰਮਾਣਿਕਤਾ ਅਤੇ ਪੁਲਿਸ ਸਟੇਸ਼ਨ ਦੀ ਤਸਦੀਕ", "ਚੋਰੀ ਦੇ ਹਾਲਾਤ ਦੀ ਪੁਸ਼ਟੀ", "ਕੀ-ਸੈੱਟ ਪ੍ਰਮਾਣਿਕਤਾ", "ਅਣਟਰੇਸਡ ਰਿਪੋਰਟ ਤਾਲਮੇਲ"]
            },
            police: {
                title: "ਪੁਲਿਸ ਸੰਪਰਕ ਅਤੇ ਕਾਨੂੰਨੀ ਤਾਲਮੇਲ",
                desc: "ਕਾਨੂੰਨ ਲਾਗੂ ਕਰਨ ਵਾਲੀਆਂ ਏਜੰਸੀਆਂ ਨਾਲ ਪੇਸ਼ੇਵਰ ਵਿਵਹਾਰ ਅਤੇ ਤਾਲਮੇਲ।",
                list: ["ਪੁਲਿਸ ਸਟੇਸ਼ਨਾਂ ਅਤੇ ਜਾਂਚ ਅਫਸਰਾਂ ਨਾਲ ਸਿੱਧਾ ਸੰਪਰਕ", "ਐਫਆਈਆਰ / ਡੀਡੀਆਰ / ਹਾਦਸੇ ਦੇ ਰਿਕਾਰਡ ਦੀ ਪੁਸ਼ਟੀ", "ਚਾਰਜਸ਼ੀਟ (173 CrPC) ਤਸਦੀਕ", "ਕੇਸ ਦੀ ਸਥਿਤੀ ਅਤੇ ਜਾਂਚ ਅੱਪਡੇਟ", "ਐਸਐਸਪੀ / ਐਸਐਚਓ / ਆਈਓ ਦਫਤਰ ਤਾਲਮੇਲ"]
            },
            rti: {
                title: "ਆਰਟੀਆਈ (ਸੂਚਨਾ ਦਾ ਅਧਿਕਾਰ) ਮਾਹਰ ਸੇਵਾਵਾਂ",
                desc: "ਪ੍ਰਮਾਣਿਤ ਪੁਲਿਸ ਅਤੇ ਸਰਕਾਰੀ ਰਿਕਾਰਡਾਂ ਦੀ ਆਰਟੀਆਈ-ਅਧਾਰਤ ਪ੍ਰਾਪਤੀ।",
                list: ["ਪੁਲਿਸ, ਆਰਟੀਓ ਅਤੇ ਹਸਪਤਾਲਾਂ ਨਾਲ ਆਰਟੀਆਈ ਦਾ ਖਰੜਾ ਤਿਆਰ ਕਰਨਾ ਅਤੇ ਦਾਇਰ ਕਰਨਾ", "ਪ੍ਰਮਾਣਿਤ ਐਫਆਈਆਰ, ਡੀਡੀਆਰ, ਐਮਐਲਸੀ ਅਤੇ ਜਾਂਚ ਰਿਕਾਰਡ", "ਮੁਸ਼ਕਲ ਪੁਲਿਸ ਦਸਤਾਵੇਜ਼ ਦੀ ਖਰੀਦ", "ਕਾਨੂੰਨੀ ਤੌਰ 'ਤੇ ਸਵੀਕਾਰਯੋਗ ਸਬੂਤ"]
            },
            risk: {
                title: "IBNR ਜੋਖਮ ਤਸਦੀਕ (ਅਗਸਤ 2022 ਤੋਂ)",
                desc: "ਪੋਰਟਫੋਲੀਓ-ਪੱਧਰ ਅਤੇ ਸ਼ੁਰੂਆਤੀ ਪੜਾਅ ਦੇ ਬੀਮਾ ਜੋਖਮ ਖੋਜ ਸਹਾਇਤਾ।",
                list: ["IBNR (ਵਾਪਰਿਆ ਪਰ ਰਿਪੋਰਟ ਨਹੀਂ ਕੀਤਾ ਗਿਆ) ਜਾਂਚ", "ਸ਼ੱਕੀ ਪੈਟਰਨ ਦੀ ਪਛਾਣ", "ਪ੍ਰੀ-ਕਲੇਮ ਫੀਲਡ ਵੈਧਤਾ", "ਪਾਲਿਸੀ-ਪੜਾਅ ਜੋਖਮ ਖੁਫੀਆ ਜਾਣਕਾਰੀ"]
            },
            accidentData: {
                title: "Road Traffic Accident Data Retrieval",
                desc: "Specialized retrieval of road traffic accident data for general insurance companies.",
                list: ["Accident data retrieval for insurers", "Traffic accident record verification", "Data support for claim processing"]
            }
        },
        process: {
            title: "ਸਾਡੀ ਜਾਂਚ ਅਤੇ ਤਸਦੀਕ ਪ੍ਰਕਿਰਿਆ",
            subtitle: "ਪੁਲਿਸ ਦੁਆਰਾ ਪ੍ਰਮਾਣਿਤ, ਕਾਨੂੰਨੀ ਤੌਰ 'ਤੇ ਸੁਰੱਖਿਅਤ ਸਬੂਤਾਂ ਲਈ ਤਿਆਰ ਕੀਤਾ ਗਿਆ",
            steps: [
                { title: "ਕੇਸ ਦਾਖਲਾ ਅਤੇ ਦਾਇਰਾ ਪਰਿਭਾਸ਼ਾ", desc: "ਦਾਅਵਾ / IBNR ਸੰਖੇਪ, ਦਸਤਾਵੇਜ਼, ਲੋੜੀਂਦੀ ਪੁਸ਼ਟੀ।" },
                { title: "ਫੀਲਡ ਜਾਂਚ ਅਤੇ ਪੁਲਿਸ ਤਾਲਮੇਲ", desc: "ਸਾਈਟ ਦਾ ਦੌਰਾ, ਪੁਲਿਸ ਪੁੱਛਗਿੱਛ, ਆਈਓ ਆਪਸੀ ਤਾਲਮੇਲ, ਸਥਾਨਕ ਖੁਫੀਆ ਜਾਣਕਾਰੀ।" },
                { title: "ਅਧਿਕਾਰਤ ਰਿਕਾਰਡ ਅਤੇ ਜੋਖਮ ਪ੍ਰਮਾਣਿਕਤਾ", desc: "ਪੁਲਿਸ ਰਿਕਾਰਡ, ਆਰਟੀਆਈ ਦਸਤਾਵੇਜ਼, FFRM / IBNR ਜਾਂਚ।" },
                { title: "ਢਾਂਚਾਗਤ ਅੰਤਿਮ ਰਿਪੋਰਟ ਸਪੁਰਦਗੀ", desc: "ਲੱਭਤਾਂ, ਅਸੰਗਤਤਾਵਾਂ, ਫੋਟੋਆਂ ਅਤੇ ਸਿੱਟੇ।" }
            ],
            ctaText: "ਤੁਰੰਤ ਪੁਲਿਸ ਜਾਂ IBNR ਤਸਦੀਕ ਦੀ ਲੋੜ ਹੈ?",
            ctaBtn: "ਤਰਜੀਹੀ ਪ੍ਰੋਸੈਸਿੰਗ ਲਈ ਕਾਲ ਕਰੋ"
        },
        coverage: {
            title: "ਮਾਹਰ ਜਾਂਚ ਕਵਰੇਜ",
            subtitle: "ਸੰਚਾਲਨ ਜ਼ੋਨਾਂ ਵਿੱਚ ਮਜ਼ਬੂਤ ਪੁਲਿਸ ਸੰਪਰਕ ਅਤੇ ਬੀਮਾਕਰਤਾ ਤਾਲਮੇਲ",
            punjab: { title: "ਪੰਜਾਬ", desc: "ਮੋਹਾਲੀ, ਚੰਡੀਗੜ੍ਹ, ਲੁਧਿਆਣਾ, ਅੰਮ੍ਰਿਤਸਰ, ਪਟਿਆਲਾ ਅਤੇ ਸੂਬਾ ਭਰ ਵਿੱਚ" },
            haryana: { title: "ਹਰਿਆਣਾ", desc: "ਪੰਚਕੂਲਾ, ਅੰਬਾਲਾ, ਕਰਨਾਲ ਅਤੇ ਆਸ ਪਾਸ ਦੇ ਜ਼ਿਲ੍ਹੇ" }
        },
        expandedStates: {
            title: "ਵਿਸਤ੍ਰਿਤ ਰਾਜ ਕਵਰੇਜ",
            desc: "ਉੱਤਰ ਪ੍ਰਦੇਸ਼, ਉੱਤਰਾਖੰਡ, ਝਾਰਖੰਡ, ਬਿਹਾਰ, ਛੱਤੀਸਗੜ੍ਹ, ਮਹਾਰਾਸ਼ਟਰ ਅਤੇ ਹੋਰਾਂ ਵਿੱਚ ਸਰਗਰਮ ਕਾਰਵਾਈਆਂ।",
            list: ["ਉੱਤਰ ਪ੍ਰਦੇਸ਼", "ਉੱਤਰਾਖੰਡ", "ਝਾਰਖੰਡ", "ਬਿਹਾਰ", "ਛੱਤੀਸਗੜ੍ਹ", "ਮਹਾਰਾਸ਼ਟਰ"]
        },
        advantage: {
            title: "GSA ਦਾ ਫਾਇਦਾ",
            items: [
                { title: "2007 ਤੋਂ ਸਰਗਰਮ", desc: "ਸਥਾਪਤ ਜਾਂਚ ਅਤੇ ਬੀਮਾਕਰਤਾ ਭਰੋਸੇਯੋਗਤਾ" },
                { title: "ਅਗਸਤ 2022 ਤੋਂ IBNR-FFRM ਪ੍ਰੋਜੈਕਟ", desc: "ਜੋਖਮ-ਤਸਦੀਕ ਡੋਮੇਨ ਵਿੱਚ ਵਿਸਤਾਰ" },
                { title: "ਪੁਲਿਸ ਤਾਲਮੇਲ ਮੁਹਾਰਤ", desc: "ਐਸਐਚਓ, ਆਈਓ ਅਤੇ ਐਸਐਸਪੀ ਦਫਤਰਾਂ ਨਾਲ ਸਿੱਧਾ ਵਿਵਹਾਰ" },
                { title: "20+ ਬੈਕਐਂਡ ਅਤੇ ਫੀਲਡ ਟੀਮ", desc: "ਮਜ਼ਬੂਤ ਦਸਤਾਵੇਜ਼ ਅਤੇ ਅਮਲ" },
                { title: "ਧੋਖਾਧੜੀ ਖੋਜ ਮੁਹਾਰਤ", desc: "ਮਨਘੜਤ ਹਾਦਸਿਆਂ ਅਤੇ ਝੂਠੀਆਂ ਕਹਾਣੀਆਂ ਦਾ ਪਤਾ ਲਗਾਉਣਾ" },
                { title: "ਸਬੂਤ-ਆਧਾਰਿਤ ਰਿਪੋਰਟਿੰਗ", desc: "ਪੁਲਿਸ ਇਨਪੁਟ + ਸਾਈਟ ਫੋਟੋਆਂ + ਗਵਾਹ ਦੇ ਬਿਆਨ" },
                { title: "ਪੈਨਲ-ਤਿਆਰ ਢਾਂਚਾਗਤ ਰਿਪੋਰਟਾਂ", desc: "ਬੀਮਾਕਰਤਾ ਅਤੇ ਕਾਨੂੰਨੀ ਫਾਰਮੈਟਾਂ ਨਾਲ ਜੁੜਿਆ ਹੋਇਆ" },
                { title: "ਤੇਜ਼ੀ ਨਾਲ ਬਦਲਾਵ (TAT)", desc: "ਸਮਾਂਬੱਧ ਡਿਲਿਵਰੀ" }
            ]
        },
        industries: {
            title: "ਉਦਯੋਗ ਜਿਨ੍ਹਾਂ ਦੀ ਅਸੀਂ ਸੇਵਾ ਕਰਦੇ ਹਾਂ",
            cardTitle: "ਨਿੱਜੀ ਜਨਰਲ ਬੀਮਾ ਕੰਪਨੀਆਂ",
            items: ["ਦਾਅਵੇ ਅਤੇ ਜੋਖਮ ਵਿਭਾਗ", "IBNR / FFRM ਪ੍ਰੋਜੈਕਟ ਟੀਮਾਂ", "ਕਾਨੂੰਨੀ ਅਤੇ ਰਿਕਵਰੀ ਯੂਨਿਟ", "ਕਾਰਪੋਰੇਟ ਜਾਂਚ ਟੀਮਾਂ"]
        },
        cta: {
            title: "ਆਪਣੇ ਬੀਮਾ ਪੋਰਟਫੋਲੀਓ ਦੀ ਰੱਖਿਆ ਕਰਨ ਲਈ ਤਿਆਰ ਹੋ?",
            desc: "ਪੰਜਾਬ ਅਤੇ ਹਰਿਆਣਾ ਦੇ ਭਰੋਸੇਮੰਦ ਮਾਹਰਾਂ ਤੋਂ ਮਾਹਰ ਜਾਂਚ ਅਤੇ ਜੋਖਮ ਤਸਦੀਕ ਸੇਵਾਵਾਂ ਪ੍ਰਾਪਤ ਕਰੋ",
            btnPrimary: "ਜਾਂਚ ਦੀ ਬੇਨਤੀ ਕਰੋ",
            btnSecondary: "ਕਾਲ ਕਰੋ +91-9814974333"
        }
    }
};
